var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 15.6001L15.828 12.0001L9.6 8.4001V15.6001ZM23.472 6.2041C23.628 6.7681 23.736 7.5241 23.808 8.4841C23.892 9.4441 23.928 10.2721 23.928 10.9921L24 12.0001C24 14.6281 23.808 16.5601 23.472 17.7961C23.172 18.8761 22.476 19.5721 21.396 19.8721C20.832 20.0281 19.8 20.1361 18.216 20.2081C16.656 20.2921 15.228 20.3281 13.908 20.3281L12 20.4001C6.972 20.4001 3.84 20.2081 2.604 19.8721C1.524 19.5721 0.828 18.8761 0.528 17.7961C0.372 17.2321 0.264 16.4761 0.192 15.5161C0.108 14.5561 0.0719999 13.7281 0.0719999 13.0081L0 12.0001C0 9.3721 0.192 7.4401 0.528 6.2041C0.828 5.1241 1.524 4.4281 2.604 4.1281C3.168 3.9721 4.2 3.8641 5.784 3.7921C7.344 3.7081 8.772 3.6721 10.092 3.6721L12 3.6001C17.028 3.6001 20.16 3.7921 21.396 4.1281C22.476 4.4281 23.172 5.1241 23.472 6.2041Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8442e951585e14b05c80216e6fe2302a.svg";
export { ForwardRef as ReactComponent };